import { render, staticRenderFns } from "./chatLeftSidebar.vue?vue&type=template&id=5161148f&scoped=true&"
import script from "./chatLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./chatLeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./chatLeftSidebar.vue?vue&type=style&index=0&id=5161148f&prod&lang=scss&"
import style1 from "./chatLeftSidebar.vue?vue&type=style&index=1&id=5161148f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161148f",
  null
  
)

export default component.exports